import React from 'react'
import { HiShieldCheck } from 'react-icons/hi'
import { MdCancel, MdAnalytics } from 'react-icons/md'

const accordion = [
  {
    icon: <HiShieldCheck />,
    title: "Best interest rates on the market",
    description: "Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim."
  },
  {
    icon: <MdCancel />,
    title: "Prevent unstable prices",
    description: "Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim."
  }, 
  {
    icon: <MdAnalytics />,
    title: "Best price on the market",
    description: "Exercitation in fugiat est ut ad ea cupidatat ut in cupidatat occaecat ut occaecat consequat est minim minim esse tempor laborum consequat esse adipisicing eu reprehenderit enim."
  }
]

export default accordion
